// components/ArticleList.tsx
import React, { useEffect } from 'react';
import { TFunction } from 'next-i18next';
import { ChatObj, EnviarChatObj, MensajesChatObj } from '@/objects/Chat';
import { useServices } from '@/context/ServicesProvider';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { LoginDatos } from '@/objects/User';
import { AxiosResponse } from 'axios';
import RowMensaje from '../elements/listas/lista_mensajes/RowMensaje';
import TextFieldCustom from '../elements/TextFieldCustom';
import BotonRedondo from '../elements/BotonFabMenu';
import { dateToDateDBT } from '@/util/MagicDate';
import SendIcon from '@mui/icons-material/Send';
import HeaderChat from './HeaderChat';
import { mostrarAlerta } from '@/context/UtilsContext';

interface Props {
  id_chat: number;
  objChat: ChatObj;
  updateLeido: () => void;
  t: TFunction;
}

const ChatConversacion: React.FC<Props> = ({ id_chat, objChat, t, updateLeido }) => {

  const { mensajesQueries } = useServices();

  const [mensajesChat, setMensajesChat] = React.useState<MensajesChatObj[]>();

  const [mensajeEnviar, setMensajeEnviar] = React.useState<string>("");

  const [id_otro_usuario, setIdOtroUsuario] = React.useState<number>();
  const [id_participante_2, setIdParticipante2] = React.useState<number>(0);

  React.useEffect(() => {
    cargarMensajesChat();
    updateLeido();
  }, []);

  useEffect(() => {
    //quiero que los mensajes hagan scroll hasta abajo del todo
    scrollAbajo();
  }, [mensajesChat]);

  function scrollAbajo() {
    var element = document.getElementById("chat");
    if (element != null) {
      element.scrollTop = element.scrollHeight;
    }
  }

  function cargarMensajesChat() {
    const datosUsuario: LoginDatos | null = cargarDatosUsuario();
    mensajesQueries?.obtenerMensajesChat(Number(datosUsuario?.id_user), id_chat).then((response: AxiosResponse<MensajesChatObj[]>) => {
      //alert("cargarMensajesChat " + JSON.stringify(response.data.mensajes_chat))
      if (response.status == 200) {
        setMensajesChat(response.data);
        const id_otro_usuario = Number(datosUsuario?.id_user) == objChat.id_participante_1 ? objChat.id_participante_2 : objChat.id_participante_1;
        //alert("id_otro_usuario " + id_otro_usuario);
        setIdOtroUsuario(id_otro_usuario);
        setIdParticipante2(Number(objChat.id_participante_2));
      }
    }).catch((error: any) => {
      console.log(error);
    }
    );
  }

  function enviarMensaje() {
    if (mensajeEnviar == "") return;

    const datosUsuario: LoginDatos | null = cargarDatosUsuario();

    var objEnviarChat: EnviarChatObj = {
      id_chat: id_chat,
      id_usuario: Number(datosUsuario?.id_user),
      id_usuario_destino: Number(datosUsuario?.id_user) == objChat.id_participante_1 ? objChat.id_participante_2 : objChat.id_participante_1,
      id_creador_articulo: mensajesChat != undefined ? mensajesChat[0].id_creador_articulo : 1,
      mensaje: mensajeEnviar,
      tipo_android_app: 0,
      id_autor: Number(datosUsuario?.id_user),
      fecha: dateToDateDBT(new Date()),
    }

    mensajesQueries?.responderChat(objEnviarChat).then((response: AxiosResponse<number>) => {
      if (response.status == 200) {
        if (response.data == -2) {//Chat bloqueado no puedes enviar
          mostrarAlerta({
            title: t('common:opciones.error'),
            content: t('contenido:chat.este_chat_ha_sido_bloqueado_no_se_puede_escribir'),
            showCancelButton: false,
          });
          return;
        }
        //Añade el mensaje al array 
        const mensaje: MensajesChatObj = {
          id_mensaje: response.data,
          id_chat: id_chat,
          id_creador_articulo: Number(objEnviarChat.id_creador_articulo),
          id_autor: objEnviarChat.id_autor,
          id_receptor: objEnviarChat.id_usuario_destino,
          mensaje: objEnviarChat.mensaje,
          leido: 0,
          push: 0,
          trato: 0,
          fecha: objEnviarChat.fecha,
          avatar_otro: ""
        }
        mensajesChat?.push(mensaje);
        setMensajesChat(mensajesChat);
        setMensajeEnviar("");
        setTimeout(() => {
          scrollAbajo();
        }, 500);
      }
    }).catch((error: any) => {
      console.log(error);
    }
    );
  }

  return (
    <div style={{
      marginLeft: "5%", marginRight: "5%", width: "90%", height: "100%",
      display: "flex", flexDirection: "column", alignItems: "center", alignContent: "center"
    }}>
      <HeaderChat id_participante_2={id_participante_2} id_otro_usuario={id_otro_usuario} id_chat={id_chat} id_articulo={objChat.id_articulo} categoria={objChat.categoria_articulo} t={t} />
      <div id="chat" style={{ overflowY: 'auto', height: '80vh', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {mensajesChat?.map((mensaje: MensajesChatObj, index: number) => {
          return (
            <div key={index} style={{ justifyContent: "center", alignItems: "center", width: "100%" }}>
              <RowMensaje t={t} mensaje={mensaje} />
            </div>
          );
        })}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', height: '20vh', width: "100%" }}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', marginRight: "20px" }}>
          <TextFieldCustom label={t("menu:secciones.mensajes.escribir_mensaje")} value={mensajeEnviar} setValue={setMensajeEnviar}
            onKeyDown={(event: React.KeyboardEvent) => {
              if (event.key === 'Enter') {
                enviarMensaje();
              }
            }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <BotonRedondo icon={<SendIcon />} textoBoton={t("menu:secciones.mensajes.enviar")} onClick={() => {
            enviarMensaje();
          }} />
        </div>
      </div>
    </div>
  );
};

export default ChatConversacion;
